import { Button, notification } from 'antd';
import { createUser } from 'redux/actions/usersActions';
import { useSelector } from 'react-redux';
import selectors from 'redux/selectors/selectors';
import BasicSlideOut from '../../shared/components/BasicSlideOut';
import useBoundForm from '../../shared/hooks/useBoundForm';
import BoundFormGroup from '../../shared/components/boundForm/BoundFormGroup';
import React, { useState } from 'react';
import { Icon } from '../../shared/components';
import { getAccountInfo } from '../../redux/actions/eCommerceActions';
import { UpgradeModal } from '../../features/upgrade/upgrade-modal';
import { LimitUpgradeModal } from '../../features/upgrade/limit-upgrade-modal';

export function AddUserWidget() {
  const isFreeTier = useSelector(selectors.isFreeTier);
  const accountInfo = useSelector(selectors.accountInfo);

  const [showFreeTierUpgrade, setShowFreeTierUpgrade] = useState(false);
  const [showLimitUpgrade, setShowLimitUpgrade] = useState(false);
  const [show, setShow] = useState(false);

  const onHide = () => {
    setShow(false);
  };

  const onSubmit = (data) => {
    createUser(data).then((response) => {
      if (response) {
        notification.success({
          key: 'UserCreated',
          message: 'Success',
          description: 'User created',
        });
      }
      onHide();
      getAccountInfo();
    });
  };

  const fieldsAdd = [[{ id: 'email', label: 'Email', placeholder: 'test@example.com' }]];
  const form = useBoundForm({});

  return (
    <>
      <Button
        onClick={() => {
          if (isFreeTier) {
            setShowFreeTierUpgrade(true);
          } else if (accountInfo?.usage?.users_usage <= accountInfo?.usage?.users_limit) {
            setShowLimitUpgrade(true);
          } else {
            setShow(true);
          }
        }}
        className="primary_big"
        icon={
          <Icon
            name="plus"
            size={12}
          />
        }>
        Add User
      </Button>
      <UpgradeModal
        show={showFreeTierUpgrade}
        onHide={() => setShowFreeTierUpgrade(false)}
      />
      <LimitUpgradeModal
        show={showLimitUpgrade}
        onHide={() => setShowLimitUpgrade(false)}
        limitType="users"
        currentUsage={accountInfo?.usage?.users_usage}
        maxLimit={accountInfo?.usage?.users_limit}
      />
      <BasicSlideOut
        showSlideOut={show}
        hideSlideOut={onHide}
        title={'Add User'}
        body={
          <BoundFormGroup
            formId={form.id}
            fields={fieldsAdd}
          />
        }
        submitText={'Add'}
        onSubmit={() => {
          onSubmit(form.state);
        }}
      />
    </>
  );
}
